import { useEffect } from 'react';
import { EventEmitterService } from 'js/services/eventEmitter.service';

export const pushDispatcher = new EventEmitterService<Record<number | string, any[]>>();

/**
 * Subscribe to pushes from server
 * @param pushIds
 * @param callback
 * @param [params] - params object for callback
 * @param [dependencies] - explicit hook dependencies
 */
export const usePushSubscription = (
    pushIds: string | number | (string | number)[],
    callback: (params: any) => (params: any) => void,
    params: object = {},
    dependencies: Array<any> = []
) => {
    const pushIdsDependency = Array.isArray(pushIds) ? pushIds : [pushIds];
    const paramsDependencies = Object.values(params);

    useEffect(() => {
        const pushHandler = callback(params);

        pushDispatcher.on(pushIdsDependency, pushHandler);

        return () => pushDispatcher.off(pushIdsDependency, pushHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...pushIdsDependency, callback, ...paramsDependencies, ...dependencies]);
};
